import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'


import {
  Carousel,
  CarouselItem,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Button
} from 'element-ui'
import '../theme/index.css'
import './assets/css/main.less'
import i18n from './lang'


Vue.prototype.$ELEMENT = {
  size: (localStorage.getItem('size') || 'medium'),
  i18n: (key, value) => i18n.t(key, value)
}

Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Dropdown)
Vue.use(DropdownItem)
Vue.use(DropdownMenu)
Vue.use(Button)

// 页面跳转后滚动条位于最上方
router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
});

// register global utility filters
// Object.keys(filters).forEach(key => {
//   Vue.filter(key, filters[key])
// })


Vue.config.productionTip = false
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')